/**
 * 新建 / 编辑项目 · 弹窗。
 *
 * 入口全部来自全国态势页（左侧「＋ 新建项目」按钮 / 地图光点悬浮卡「编辑」），
 * 因此不再有独立的项目管理页。
 *
 * 复用 `ProjectForm`（embedded 模式），只负责外壳：标题 + 遮罩 + 关闭。
 */

import Modal from '../../components/Modal';
import ProjectForm from './ProjectForm';
import type { ProjectDetail } from './api';

export interface ProjectFormDialogProps {
  open: boolean;
  mode: 'create' | 'edit';
  /** 编辑态必传 */
  projectId?: string;
  onClose(): void;
  /** 保存成功回调（创建 / 编辑共用） */
  onSaved?(project: ProjectDetail): void;
}

export default function ProjectFormDialog({
  open,
  mode,
  projectId,
  onClose,
  onSaved,
}: ProjectFormDialogProps) {
  return (
    <Modal
      open={open}
      title={mode === 'edit' ? '编辑项目' : '新建项目'}
      onClose={onClose}
      className="pm-form-dialog"
    >
      <ProjectForm
        mode={mode}
        projectId={projectId}
        embedded
        onCancel={onClose}
        onSaved={onSaved}
      />
    </Modal>
  );
}
